import { BrandKit } from "@redotech/redo-model/brand-kit";
import { memo } from "react";
import { Card } from "./card";
import { Flex } from "./flex";
import { Text } from "./text";
import { BgColorValue } from "./theme/box";

export const ContactCard = memo(function ContactCard({
  brandKit,
  bgColor = "tertiary",
}: {
  brandKit: BrandKit | undefined;
  bgColor?: BgColorValue;
}) {
  const contactCard = brandKit?.contactCard;
  if (!contactCard || !contactCard.contactCardSrc) {
    return null;
  }
  const { firstName, lastName, logoUrl } = contactCard;
  const initials =
    `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`.toUpperCase();
  const fullName = `${firstName ?? ""} ${lastName ?? ""}`.trim();
  return (
    <Card
      bgColor={bgColor}
      borderColor="primary"
      height="fit-content"
      p="xs"
      radius="xs"
    >
      <Flex justify="space-between">
        <Flex dir="column" gap="xxs" p="sm">
          <Text fontSize="xs" fontWeight="semibold" textColor="primary">
            {fullName}
          </Text>
          <Text fontSize="xxs" textColor="secondary">
            Contact card
          </Text>
        </Flex>
        {logoUrl ? (
          <img
            alt={initials}
            src={logoUrl}
            style={{
              width: 40,
              height: 40,
              objectFit: "cover",
              borderRadius: "50%",
            }}
          />
        ) : (
          <div
            style={{
              width: 40,
              height: 40,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#ccc",
              borderRadius: "50%",
              fontSize: 16,
              color: "#fff",
              fontWeight: "bold",
            }}
          >
            {initials}
          </div>
        )}
      </Flex>
    </Card>
  );
});
